import { updateDialog } from '@Containers/Dialogs/DialogsActions';

import { typeOfZeroFilterResults } from './ZeroFilterResultsConstants';

// eslint-disable-next-line import/prefer-default-export
export function open() {
  return updateDialog({
    id: typeOfZeroFilterResults,
    animated: false,
    movable: false,
    size: 'md',
    dialogType: typeOfZeroFilterResults,
  });
}
